// extracted by mini-css-extract-plugin
export var tableOfContents = "ArticleTableOfContents-module--tableOfContents--3k-BI";
export var link = "ArticleTableOfContents-module--link--11FFt";
export var linkText = "ArticleTableOfContents-module--linkText--3i-D8";